import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function StrategicVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="strategic-vision" className="dark bg-background text-foreground relative w-full min-h-[70vh] flex items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562991/img/monochrome_city_skyline_parallax.png')] bg-cover bg-center bg-fixed opacity-30 grayscale" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/40 to-background/90" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 container mx-auto px-6 md:px-12 flex flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <blockquote className="max-w-5xl mx-auto mb-16">
          <p className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.1] tracking-tight text-white drop-shadow-2xl">
            &ldquo;Capital is not merely fuel for growth. It is the structural foundation of legacy.&rdquo;
          </p>
        </blockquote>

        <Link to="/ContactPage">
          <Button size="lg" className="h-14 px-12 text-lg uppercase tracking-widest rounded-none border border-white/30 bg-transparent text-white hover:bg-white hover:text-black hover:border-white transition-all duration-500 shadow-[0_0_20px_rgba(0,0,0,0.5)]">
            Request Capital
          </Button>
        </Link>
      </div>
    </section>;
}